import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    class: ["container-centered", _vm.$whitelabel.WineListCustomerFiltersHidden ? "small" : ""]
  }, [_c("div", {
    attrs: {
      id: "content"
    }
  }, [!_vm.$whitelabel.WineListCustomerFiltersHidden ? _c("div", {
    attrs: {
      id: "wine-filters"
    }
  }, [_vm.isWineList ? _c("WineFilters", {
    attrs: {
      filters: _vm.searchCriterias.filters,
      listWineTypes: _vm.availableWineTypes.filter(function (x) {
        return x.name != "Spirit";
      }),
      producers: _vm.listProducers,
      appellations: _vm.listAppellations,
      listCountries: _vm.listWineCountries,
      listRegions: _vm.listWineRegions,
      storageLocations: _vm.storageLocations,
      hasAnySpecialDeal: _vm.hasAnySpecialDeal,
      loggedUserData: _vm.loggedUserData,
      isPriceRangeFiltererShown: _vm.isPriceRangeFiltererShown
    },
    on: {
      filtersChanged: _vm.filtersChanged
    }
  }) : _vm._e(), _vm.isSpiritList ? _c("SpiritsFilters", {
    attrs: {
      filters: _vm.searchCriterias.filters,
      producers: _vm.listProducers,
      appellations: _vm.listAppellations,
      listCountries: _vm.listSpiritCountries,
      listRegions: _vm.listSpiritRegions,
      storageLocations: _vm.storageLocations,
      hasAnySpecialDeal: _vm.hasAnySpecialDeal,
      loggedUserData: _vm.loggedUserData
    },
    on: {
      filtersChanged: _vm.filtersChanged
    }
  }) : _vm._e()], 1) : _vm._e(), _c("div", {
    attrs: {
      id: "wine-list-global-container"
    }
  }, [_vm.thirdPartyOrder || _vm.canManageWines || _vm.canExportPriceList ? _c("div", {
    staticClass: "actions-top-container"
  }, [_c("div", {
    staticClass: "target-selectors-container"
  }, [_c("TargetSelectors", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      changeThirdPartyUserSelected: _vm.updateThirdPartyUser,
      changePricePostingSelected: _vm.updatePricePostingMonth
    }
  }), false && !!_vm.thirdPartyUserId && _vm.loggedUserData.isSuperAdmin && !!_vm.currentOrder ? _c("div", {
    staticClass: "flex gap-2"
  }, [_c("div", {
    staticClass: "target-selectors-container--label"
  }, [_vm._v("Change creator to")]), _c("div", [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.adminUsers,
      "item-value": "id_user",
      "item-text": "fullname",
      "hide-selected": "",
      "hide-no-data": "",
      "hide-details": "auto"
    },
    on: {
      change: _vm.changeCreator
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "bold"
        }, [_vm._v(_vm._s(item.fullname) + " -")]), _c("div", {
          staticClass: "text-sm text-italic ml-1"
        }, [_vm._v(_vm._s(item.login))])];
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(+_vm.loggedUserData.idUser === +item.id_user ? "Me" : item.fullname) + " ")];
      }
    }], null, false, 1267299854),
    model: {
      value: _vm.selectedThirdPartyOwnerId,
      callback: function callback($$v) {
        _vm.selectedThirdPartyOwnerId = $$v;
      },
      expression: "selectedThirdPartyOwnerId"
    }
  })], 1)]) : _vm._e()], 1), _vm.canManageWines || _vm.canImportOrder || _vm.canExportPriceList ? _c("div", {
    staticClass: "list-actions-admin"
  }, [!_vm.isLoadingFilters ? [_vm.canImportOrder ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true,
      disabled: _vm.isLoadingFilters
    },
    on: {
      click: function click($event) {
        return _vm.importOrder();
      }
    }
  }, [_c(VIcon, {
    staticClass: "--margin-right",
    attrs: {
      dark: ""
    }
  }, [_vm._v("fas fa-file-upload")]), _vm._v(" Import order ")], 1) : _vm._e(), _vm.canExportPriceList ? _c(VBtn, {
    staticClass: "dfwa-btn --small highlight",
    attrs: {
      rounded: true,
      to: _vm.openExportPriceList(),
      target: "_blank",
      disabled: _vm.isLoadingFilters
    }
  }, [_c(VIcon, {
    staticClass: "--margin-right",
    attrs: {
      dark: ""
    }
  }, [_vm._v("fas fa-file-invoice-dollar")]), _vm._v(" Price list ")], 1) : _vm._e(), _vm.canManageWines ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      to: _vm.newWine(),
      disabled: _vm.isLoadingFilters
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s("new ".concat(_vm.isSpiritList ? "spirit" : "wine")) + " ")], 1) : _vm._e()] : _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      disabled: "",
      loading: ""
    }
  }, [_vm._v(" Price list ")])], 2) : _vm._e()]) : _vm._e(), !_vm.$whitelabel.WineListCustomerSearchAndPaginationHidden ? _c("div", {
    attrs: {
      id: "search-criterias"
    }
  }, [_c("div", {
    staticClass: "search-criteria"
  }, [_c(VTextField, {
    attrs: {
      solo: "",
      clearable: "",
      placeholder: "Search for a label, ".concat(_vm.isSpiritList ? "spirit, distillery" : "wine, winery", " ..."),
      "append-icon": "fa-search",
      loading: _vm.loadingSearch,
      "hide-details": "auto"
    },
    on: {
      blur: function blur($event) {
        !!_vm.searchCriterias.searchLabel && _vm.advancedSearch();
      },
      "click:append": function clickAppend($event) {
        return _vm.advancedSearch();
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.advancedSearch();
      },
      "click:clear": function clickClear() {
        _vm.searchCriterias.searchLabel = null;
        _vm.advancedSearch();
      }
    },
    model: {
      value: _vm.searchCriterias.searchLabel,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "searchLabel", $$v);
      },
      expression: "searchCriterias.searchLabel"
    }
  })], 1), !_vm.isMobile() ? _c("div", {
    staticClass: "pagination-right"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      solo: "",
      items: _vm.pagingLimitsChoices,
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.advancedSearch();
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1) : _vm._e()]) : _vm._e(), _c("div", {
    attrs: {
      id: "wine-list-wrapper"
    }
  }, [!_vm.baseModel.wines || _vm.baseModel.wines.length === 0 && !_vm.loadingSearch ? _c("div", {
    staticClass: "list-empty"
  }, [_vm._v(" " + _vm._s(_vm.isSpiritList ? "No spirit available." : "No wine available.") + " ")]) : [_vm.loadingSearch ? _c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "45",
      width: "3"
    }
  }) : _c("div", {
    staticClass: "wine-list"
  }, _vm._l(_vm.baseModel.wines, function (wine) {
    return _c("div", {
      key: "".concat(wine.id_wine, "_").concat(_vm.currency, "_").concat(wine.customerPriceEuro)
    }, [_c("WineCard", {
      attrs: {
        wineProp: wine,
        isAddingToCart: _vm.isAddingToCart,
        loggedUserData: _vm.loggedUserData,
        currency: _vm.currency
      },
      on: {
        changeQuantityOrder: _vm.changeQuantityOrder,
        addItemToCart: _vm.addItemToCart
      }
    })], 1);
  }), 0)]], 2), !_vm.loadingSearch && !_vm.$whitelabel.WineListCustomerSearchAndPaginationHidden && _vm.baseModel.numberOfPages >= 2 ? _c("div", {
    staticClass: "pagination-bottom"
  }, [_c("div", [_c("paging", {
    attrs: {
      numberOfPages: _vm.baseModel.numberOfPages,
      currentPage: _vm.searchCriterias.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "pagination-right"
  }, [!_vm.isMobile() ? _c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: ""
    },
    on: {
      change: function change($event) {
        return _vm.advancedSearch();
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("div", {
    staticClass: "button-end-page-container --right"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary",
    attrs: {
      rounded: "",
      loading: _vm.exportingList.isPending,
      disabled: _vm.exportingList.isPending
    },
    on: {
      click: function click($event) {
        return _vm.launchExport();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-download mr-1",
    attrs: {
      size: "0.8rem"
    }
  }), _vm._v(" Export all " + _vm._s(_vm.isWineList ? "wines" : "spirits") + " ")], 1)], 1) : _vm._e()])])]), _vm.canImportOrder ? _c("ImportOrderDialogVue", {
    key: _vm.isImportOrderShown,
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    model: {
      value: _vm.isImportOrderShown,
      callback: function callback($$v) {
        _vm.isImportOrderShown = $$v;
      },
      expression: "isImportOrderShown"
    }
  }) : _vm._e(), _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("WineStockListModal", {
    key: _vm.wineStockKey,
    ref: "WineStockListModal",
    attrs: {
      wine: _vm.currentWine,
      quantity: _vm.currentQuantity,
      casingId: _vm.casingIdSelected,
      add: _vm.addItemToCart,
      isBasket: true
    },
    on: {
      closed: _vm.closeWineStockListModal
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };